import { showAlert } from "helper";
import PropTypes from 'prop-types';
import { UserPlanEnum } from "Enums";
import styled from 'styled-components';
import EditIcon from "mdi-react/EditIcon";
import Badge from '@/shared/components/Badge';
import Panel from "@/shared/components/Panel";
import { colorAdditional } from '@/utils/palette';
import React, { useEffect, useState } from 'react';
import EditCreateAssetRequest from "./EditGeoAIRequestLimit";
import GeoAIAdminInterface from "@/utils/GeoAIAdminInterface";
import { paddingLeft, paddingRight } from '@/utils/directions';
import SimpleModal from '@/shared/components/Modal/SimpleModal';
import { colorGreenHover, colorRedHover } from '@/utils/palette';
import ReactTableBase from '@/shared/components/table/ReactTableBase';

const CartTableButton = styled.button`
  background: transparent;
  border: none;
  line-height: 14px;
  ${paddingLeft}: 20px;
  ${paddingRight}: 0;
  padding-top: 0;
  padding-bottom: 0;
  position: relative;
  color: ${colorAdditional};
  cursor: pointer;
  transition: all 0.3s;

  svg {
    height: 20px;
    width: 20px;
    fill: ${colorAdditional};
    transition: all 0.3s;
  }

  svg:hover {
    fill: ${colorGreenHover};
  }

  .red-hover:hover {
    fill: ${colorRedHover};
  }
`;

const StatusFormatter = value => (
    value ? <Badge bg="success">True</Badge> : <Badge bg="secondary">False</Badge>
);

StatusFormatter.propTypes = {
    value: PropTypes.bool.isRequired,
};

const GeoAIRequestLimitsList = () => {
    const [selectedRequestLimit, setSelectedRequestLimit] = useState();
    const [GeoAIRequestLimitsList, setGeoAIRequestLimitsList] = useState({ tableHeaderData: [], tableRowsData: [] });
    const tableConfig = {
        isEditable: false,
        isSortable: true,
        isResizable: false,
        withPagination: false,
        withSearchEngine: true,
        placeholder: 'Search...',
    };

    const handleEdit = (request) => {
        setSelectedRequestLimit(request);
    }

    const handleModalClose = () => {
        setSelectedRequestLimit();
        getGeoAIRequestLimitsData();
    }
    
    const getGeoAIRequestLimitsData = () => {
        GeoAIAdminInterface.instance.getGeoAIRequestLimits().then((response) => {
            const columns = [
                {
                    accessor: 'plan',
                    Header: 'Plan',
                },
                {
                    accessor: 'no_requests_per_month',
                    Header: '# Requests / month',
                },
                {
                    accessor: 'edit',
                    Header: 'Edit',
                    disableGlobalFilter: true,
                    disableSortBy: true,
                }
            ];
            const data = [];
            response.data.forEach(request => {
                data.push({
                    plan: request.plan ? Object.keys(UserPlanEnum).find(key => UserPlanEnum[key] === request.plan) : '',
                    no_requests_per_month: request.no_requests_per_month,
                    edit: <CartTableButton type="button" onClick={() => handleEdit(request)}><EditIcon /></CartTableButton>,
                });
            });

            const GeoAIRequestLimitsListTableData = { tableHeaderData: columns, tableRowsData: data };
            setGeoAIRequestLimitsList(GeoAIRequestLimitsListTableData);
        }).catch((error) => {
            showAlert('error', error.response?.data?.detail);
        })
    };

    useEffect(() => {
        getGeoAIRequestLimitsData();
    }, []);

    return (
        <Panel lg={12} xl={12} md={12} title='GeoAI Requests List' refreshRequest={() => getGeoAIRequestLimitsData()} dismissButton={() => {return}}>
            <ReactTableBase
                columns={GeoAIRequestLimitsList.tableHeaderData}
                data={GeoAIRequestLimitsList.tableRowsData}
                tableConfig={tableConfig}
            />
            <SimpleModal isActive={selectedRequestLimit !== undefined} onClose={handleModalClose}>
                <EditCreateAssetRequest request={selectedRequestLimit} />
            </SimpleModal>
        </Panel>
    );
};

GeoAIRequestLimitsList.propTypes = {
    GeoAIRequestLimitsListTableData: PropTypes.shape({
        tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string,
            name: PropTypes.string,
        })),
        tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    }).isRequired,
};

export default GeoAIRequestLimitsList;
